import React, {Component} from 'react';

import OptionsElement from './options-element'

export default class Options extends Component{
	render(){
		const {mainstate, typewindowdata, onChangeOptionCheckbox} = this.props;
		const {valute} = this.props.mainstate;

		const elements = mainstate.storeOptions.map( (item, id) => {
			const {...itemProps} = item;
			return (
				<React.Fragment key={id}>
					<OptionsElement
						{...itemProps}
						id = {id}
						window_height = {mainstate.window_height}
						window_width = {mainstate.window_width}
						onChangeOptionCheckbox = {onChangeOptionCheckbox}
						currentTypeWindowId = {mainstate.currentTypeWindowId}
						typewindowdata = {typewindowdata}
						valute = {valute}
					/>
				</React.Fragment>
			)
		});

		return (
			<div className="wincalc-options wincalc-widget text-uppercase">
				<div className="wincalc-box">
					{elements}
				</div>
			</div>
		)
	}
}